$(() => {
  const hide_benefits_if_ss = () => {
    if ($('.self-service').length === 0) {
      return;
    }

    const fade = 400;
    $('#tier-wrapper').slideUp(fade);
    $('#more-than-one-authority-wrapper').slideUp(fade);
    $('#monthly-hours-managing-transponders-wrapper').slideUp(fade);
    $('#monthly-hours-managing-payment-wrapper').slideUp(fade);
  };

  hide_benefits_if_ss();
});
